import { IServiceState } from "./namespace";
import { initialCommunication } from "../../helpers/redux";

export default {
  vkState: undefined,
  isInit: false,
  authState: undefined,
  session: {
    code: undefined,
    access_token: undefined,
    refresh_token: undefined,
    access_token_expiration_time: undefined,
    access_token_datetime: undefined,
  },
  settings: {
    vk_app_id: "7752610",
    vk_mobile_app_ver_ios: "7.28",
    vk_mobile_app_ver_android: "7.28",
  },
  version: undefined,
  communication: {
    oauthGosuslugi: initialCommunication,
    vkAppVersion: initialCommunication,
    settings: initialCommunication,
    accessToken: initialCommunication,
    refreshToken: initialCommunication,
  },
} as IServiceState;
